import { Component, computed, inject, input, OnInit, signal } from '@angular/core'
import { Router } from '@angular/router'
import { NgClass } from '@angular/common'
import { WizardquoteService } from '../services/wizardquote.service'
import { WizardQuoteInstaller } from '../interfaces/wizardquote-installer.interface'
import { ConfigService } from '../../../services/config.service'

@Component({
    selector: 'sf-wizardquote-installer',
    imports: [NgClass],
    templateUrl: './wizardquote-installer.component.html',
    styleUrl: './wizardquote-installer.component.scss',
})
export class WizardquoteInstallerComponent implements OnInit {
    #configService = inject(ConfigService)
    #router = inject(Router)
    #wizardquoteService = inject(WizardquoteService)

    config = this.#configService.config

    id = input.required<string>()

    wizardQuote = signal<WizardQuoteInstaller | null>(null)

    addressLines = computed(() => {
        const customer = this.wizardQuote()?.customerInstallerModel
        if (!customer) {
            return []
        }
        return [customer.line1, customer.line2, customer.line3, customer.line4, customer.postcode].filter(
            line => !!line
        )
    })

    ngOnInit(): void {
        this.#wizardquoteService.getInstallerWizardquote(this.id()).subscribe({
            next: quote => {
                this.wizardQuote.set(quote)
            },
            error: err => {
                this.#router.navigate(['/error'], {
                    queryParams: { message: 'Failed to load quote' },
                })
            },
        })
    }
}
